export default __webpack_public_path__ + "8998c2eb930e6d2441a2b9049ef827e3.jpg";